import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
 
    state: {
      // 存储token
      token:undefined,
      userName:undefined,
      id:undefined           // 可选
    },
    getters: {
      getToken(state){
          return state.token || localStorage.getItem("token") || "";
      }
    },
    mutations: {
      // 修改token，并将token存入localStorage
      setToken(state,token) {
        state.token = token;
        localStorage.setItem('token', token);
        
        console.log('store、localstorage保存token成功！'+localStorage.getItem('token'));
      },
      delToken(state) {
        state.token = "";
        localStorage.removeItem("token");
      },
      // 可选
      setUserInfo(state, userName) {
        state.userName = userName;
        localStorage.setItem('userName', userName);
      },
      setId(state, id) {
        state.id = id;
        localStorage.setItem('userId', id);
      }
    },
   
   actions: {
     // removeToken: (context) => {
       // context.commit('setToken')
     // }
   },
  });
    
  export default store;



// WEBPACK FOOTER //
// ./src/store/index.js